/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'chevron-up': {
    width: 16,
    height: 16,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M9.646 6.146a.5.5 0 01.638-.057l.07.057 7 7a.5.5 0 01-.638.765l-.07-.057L10 7.207l-6.646 6.647a.5.5 0 01-.638.057l-.07-.057a.5.5 0 01-.057-.638l.057-.07 7-7z" _fill="#1D3861"/>'
  }
})
